"use strict";
exports.__esModule = true;
var react_idle_timer_1 = require("react-idle-timer");
var useMyIdleTimer = function (onIdle, timeout) {
    if (timeout === void 0) { timeout = 60; }
    react_idle_timer_1.useIdleTimer({
        timeout: 1000 * 60 * timeout,
        onIdle: onIdle,
        debounce: 500
    });
};
exports["default"] = useMyIdleTimer;
